import YYTag from './tag'

export default YYTag